import { render, staticRenderFns } from "./ContactListPage.vue?vue&type=template&id=050dc91c&"
import script from "./ContactListPage.vue?vue&type=script&lang=js&"
export * from "./ContactListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports